import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import { IconButton, TablePagination, Tooltip } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React from "react";
import { useSelector } from "react-redux";
import useSubscription from "../../../hooks/useSubscription";
import Emptystate from "../emptystate/emptystate";
import Spinner from "../spinner/spinner";
import classes from "./subscriptiontable.module.css";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";

const SubscriptionTable = () => {
   const { getSubscriptions, toggleLockUser, toggleEnableUser } =
      useSubscription();

   const {
      susbcriptions: { subscriptionResponse, getLoading },
   } = useSelector((state) => state);

   const handleChangePage = (_, newPage) => {
      getSubscriptions({
         pageSize: subscriptionResponse?.pageable?.pageSize,
         pageNo: newPage,
      });
   };

   const handleChangeRowsPerPage = (event) => {
      getSubscriptions({ pageSize: event.target.value, pageNo: 0 });
   };

   return (
      <>
         <TableContainer
            component={Paper}
            sx={{ maxHeight: "60vh", maxWidth: "90vw" }}
         >
            {getLoading ? (
               <Spinner />
            ) : (
               subscriptionResponse?.content &&
               subscriptionResponse?.content?.length > 0 && (
                  <Table stickyHeader aria-label="sticky table">
                     <TableHead>
                        <TableRow className={classes.table_row}>
                           <TableCell className={classes.table_cell}>
                              Full Name
                           </TableCell>
                           <TableCell className={classes.table_cell}>
                              Amount
                           </TableCell>
                           <TableCell className={classes.table_cell}>
                              Subscription Type
                           </TableCell>
                           <TableCell className={classes.table_cell}>
                              Subscription date
                           </TableCell>
                           <TableCell className={classes.table_cell}>
                              Expiry date
                           </TableCell>
                           <TableCell className={classes.table_cell}>
                              Action
                           </TableCell>
                        </TableRow>
                     </TableHead>
                     <TableBody>
                        <>
                           {subscriptionResponse?.content.map(
                              (subscription) => (
                                 <TableRow
                                    key={subscription.id}
                                    sx={{
                                       "&:last-child td, &:last-child th": {
                                          border: 0,
                                       },
                                    }}
                                 >
                                    <TableCell
                                       component="th"
                                       scope="row"
                                       style={{ minWidth: 350 }}
                                    >
                                       {subscription?.userDetails?.fullName}
                                    </TableCell>
                                    <TableCell style={{ minWidth: 200 }}>
                                       {
                                          subscription?.subscriptionPlan
                                             ?.currencySymbol
                                       }{" "}
                                       {subscription?.subscriptionPlan?.amount}
                                    </TableCell>
                                    <TableCell style={{ minWidth: 200 }}>
                                       {
                                          subscription?.subscriptionPlan
                                             ?.durationType
                                       }
                                    </TableCell>
                                    <TableCell style={{ minWidth: 200 }}>
                                       {subscription?.subscriptionDate}
                                    </TableCell>
                                    <TableCell style={{ minWidth: 200 }}>
                                       {subscription?.expiryDate}
                                    </TableCell>

                                    <TableCell style={{ minWidth: 200 }}>
                                       <Tooltip
                                          title={
                                             subscription?.userDetails?.enabled
                                                ? "Deactivate user"
                                                : "Activate user"
                                          }
                                       >
                                          <IconButton
                                             onClick={() =>
                                                toggleEnableUser(
                                                   subscription?.userDetails
                                                )
                                             }
                                          >
                                             {subscription?.userDetails
                                                ?.enabled ? (
                                                <PersonRemoveIcon
                                                   className={classes.delete}
                                                />
                                             ) : (
                                                <PersonAddIcon
                                                   className={classes.edit}
                                                />
                                             )}
                                          </IconButton>
                                       </Tooltip>

                                       <Tooltip
                                          title={
                                             subscription?.userDetails
                                                ?.accountNonLocked
                                                ? "Lock user"
                                                : "Unlock user"
                                          }
                                       >
                                          <IconButton
                                             onClick={() =>
                                                toggleLockUser(
                                                   subscription?.userDetails
                                                )
                                             }
                                          >
                                             {subscription?.userDetails
                                                ?.accountNonLocked ? (
                                                <LockOpenIcon
                                                   className={classes.edit}
                                                />
                                             ) : (
                                                <LockIcon
                                                   className={classes.delete}
                                                />
                                             )}
                                          </IconButton>
                                       </Tooltip>
                                    </TableCell>
                                 </TableRow>
                              )
                           )}
                        </>
                     </TableBody>
                  </Table>
               )
            )}
         </TableContainer>
         {!getLoading &&
            subscriptionResponse?.content &&
            subscriptionResponse?.content?.length > 0 && (
               <TablePagination
                  count={subscriptionResponse.totalElements ?? 0}
                  shape="rounded"
                  page={subscriptionResponse?.pageable?.pageNumber ?? 0}
                  rowsPerPage={subscriptionResponse?.pageable?.pageSize ?? 10}
                  className={classes.pagination}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
               />
            )}

         {!getLoading &&
            (!subscriptionResponse?.content ||
               subscriptionResponse?.content?.length === 0) && (
               <Emptystate name="Subscription payment" />
            )}
      </>
   );
};

export default SubscriptionTable;
